import { useCallback } from 'react';

import { useSubmitOrderUsingBillingAccountMutation } from '../../GraphQL/Checkout.generated';
import {
  type CheckoutInput,
  processSubmitResponse,
  type SubmitWithBillingAccountResponse,
  VALIDATION_ERROR,
} from './common';

/**
 * Uses a {billingAccountId} to submit an order.
 */
export function useSubmitOrderUsingBillingAccount() {
  const [response, mutation] = useSubmitOrderUsingBillingAccountMutation();

  const result = response.data?.submitOrderUsingBillingAccount;
  const isSubmittingOrder = response.fetching;

  const rewardFailureCode =
    result?.__typename === 'RewardNotValidated'
      ? result.failureCode
      : undefined;

  const submitOrderMutation = useCallback(
    async (input: CheckoutInput) => {
      if (!input.paymentMethodId) return VALIDATION_ERROR;

      const submitResponse = await mutation({
        input: {
          billingAccountId: input.paymentMethodId,
          orderId: input.orderId,
          wantedTime: input.wantedTime,
          useCredit: input.useCredit,
          dropoffLocationId: input.dropoffLocationId,
          contactNumber: input.contactNumber,
          includeUtensils: input.includeUtensils,
          deliveryOrderDetail: input.deliveryOrderDetail,
        },
      });

      return processSubmitResponse(
        submitResponse as SubmitWithBillingAccountResponse,
      );
    },
    [mutation],
  );

  return {
    isSubmittingOrder,
    rewardFailureCode,
    submitOrderMutation,
  };
}
